/**
 * ecount-sync/types — 실사 탭(/inventory/stocktake)의 상태와 화면 말.
 *
 * 단계는 저장하지 않는다 — preview · report 의 유무가 단계다(고르기 → 미리보기 → 반영됨).
 * 잇기 입력(product id)은 줄 안 input 에서 누를 때 읽는다 — 상태가 아니다.
 * VOCABULARY "이카운트 동기화 — 실사 탭".
 */
import type * as api from '../../api/client';

/** 올리기 폼 — 자료 · 내보낸 날('YYYY-MM-DD') · 파일 · 구매현황의 "현황" 파일 */
export interface UploadForm {
  sheet:       api.EEcountSheet;
  exportedAt:  string;
  file:        File | null;
  slipFile: File | null;
}

export interface EcountSyncData {
  form:     UploadForm;
  preview:  api.SyncPreview | null;        // 올리거나 업로드를 연 뒤. null = 아직 고르는 중
  report:   api.SyncReport | null;         // 반영 뒤. preview 와 같은 업로드
  uploads:  api.EcountUploadView[];        // 업로드 내역 — 최근 먼저
  unlinked: api.UnmappedItemView[];        // 연결 안 된 품목
  loading:  boolean;
  error:    string;                        // '' 이면 오류 없음
}

/** 화면 말 — 자료 이름은 이카운트 메뉴 그대로 */
export const SHEET_WORD: Record<api.EEcountSheet, string> = { item: '품목등록', stock: '재고현황', purchase: '구매현황' };
export const VERDICT_WORD: Record<api.ERowVerdict, string> = { new: '새것', same: '같음', changed: '다름', missing: '빠짐' };
export const LINK_PLAN_WORD: Record<api.ELinkPlan, string> = { keep: '그대로', link: '잇기', create: '만들기', unmapped: '연결 안 됨' };
export const MATCH_KIND_WORD: Record<api.EMatchKind, string> = { pn: '파트넘버로', manual: '사람이', none: '연결 안 됨' };
export const WARNING_WORD: Record<api.EStockWarning, string> = { negative: '음수', short: '못 뺌', unlinked: '연결 안 됨' };
